import { createStore } from 'satcheljs';
export default createStore('messageFormatOption', {
    showBcc: null,
    showFrom: null,
    composeFormat: null,
    fontFamily: null,
    fontSize: null,
    isFontBold: null,
    isFontItalic: null,
    isFontUnderline: null,
    fontColor: null,
    isColorMenuShown: false,
})();
//# sourceMappingURL=store.js.map